import type { AppContext } from 'types/common'
import component from './Chart.svelte'
import { checkSessionPermission } from 'utility/permission'
import showErrorAndRedirect from 'utility/show-error-and-redirect'

export default ({ stateRouter, mediator, i18next: { t: translate } }: AppContext) => {
	stateRouter.addState({
		name: 'app.configuration.dashboard.chart',
		route: 'chart',
		querystringParameters: ['lastSaveTime'],
		defaultParameters: {
			selectedChartId: null,
		},
		template: {
			svelte: true,
			component,
		},
		resolve(_data, parameters) {
			if (!checkSessionPermission('DASHBOARD_CHART_EDIT')) {
				throw showErrorAndRedirect(
					mediator,
					translate('error.permissionDenied', 'Permission Denied'),
					translate(
						'error.youDoNotHavePermissionToEditDashboardCharts',
						'You do not have permission to edit dashboard charts.',
					),
					{
						name: 'app.configuration',
					},
				)
			}

			return Promise.resolve({
				// doesn't need to be a query string parameter though
				selectedChartId: parameters.selectedChartId ? parseInt(parameters.selectedChartId, 10) : null,
			})
		},
	})
}
